import { BaseApi } from './base';

class TransactionsApi extends BaseApi {
  constructor() {
    super('transactions');
  }

  getLessonsPayments() {
    return this.get('/lessons');
  }

  getTransactions() {
    return this.get('');
  }
}

export default new TransactionsApi();
